/* global Swiper */

const REST_BASE = window.wpApiSettings?.root
	? window.wpApiSettings.root.replace( /\/$/, '' ) + '/chalk/v1/locations'
	: '/wp-json/chalk/v1/locations';

// ---------------------------------------------------------------------------
// Utilities
// ---------------------------------------------------------------------------

function debounce( fn, ms ) {
	let timer;
	return ( ...args ) => {
		clearTimeout( timer );
		timer = setTimeout( () => fn( ...args ), ms );
	};
}

async function fetchLocations( blockId, params = {} ) {
	const url = new URL( REST_BASE, window.location.origin );
	url.searchParams.set( 'block_id', blockId );
	Object.entries( params ).forEach( ( [ k, v ] ) => {
		if ( v !== '' && v !== null && v !== undefined ) {
			url.searchParams.set( k, v );
		}
	} );

	const res = await fetch( url.toString() );
	if ( ! res.ok ) throw new Error( `chalk-nursery-locations: fetch failed ${ res.status }` );
	return res.json(); // { html, hasMore, total }
}

function setLoading( wrapper, loading ) {
	wrapper.classList.toggle( 'chalk-nursery-locations--loading', loading );
}

function replaceGrid( wrapper, html ) {
	const grid = wrapper.querySelector( '.chalk-nursery-locations__grid' );
	if ( grid ) grid.innerHTML = html;
}

function appendGrid( wrapper, html ) {
	const grid = wrapper.querySelector( '.chalk-nursery-locations__grid' );
	if ( ! grid ) return;
	const tmp = document.createElement( 'div' );
	tmp.innerHTML = html;
	Array.from( tmp.children ).forEach( ( child ) => grid.appendChild( child ) );
}

function syncLoadMoreButton( wrapper, hasMore, nextPage ) {
	const btn = wrapper.querySelector( '.chalk-nursery-locations__load-more' );
	if ( ! btn ) return;
	if ( hasMore ) {
		btn.dataset.page = nextPage;
		btn.style.display = '';
	} else {
		btn.style.display = 'none';
	}
}

// ---------------------------------------------------------------------------
// Grid: load more
// ---------------------------------------------------------------------------

function initGrid( wrapper ) {
	const blockId = wrapper.dataset.blockId;
	if ( ! blockId ) return;

	const loadMoreEl = wrapper.querySelector( '.chalk-nursery-locations__load-more' );

	const getState = () => ( {
		page: parseInt( wrapper.dataset.page || '1', 10 ),
	} );

	if ( loadMoreEl ) {
		loadMoreEl.addEventListener( 'click', async () => {
			const page = parseInt( loadMoreEl.dataset.page || '2', 10 );
			const state = getState();
			loadMoreEl.disabled = true;
			setLoading( wrapper, true );
			try {
				const data = await fetchLocations( blockId, { ...state, page } );
				appendGrid( wrapper, data.html );
				syncLoadMoreButton( wrapper, data.hasMore, page + 1 );
			} catch ( e ) {
				console.error( e );
			} finally {
				loadMoreEl.disabled = false;
				setLoading( wrapper, false );
			}
		} );
	}
}

// ---------------------------------------------------------------------------
// Slider: Swiper init
// ---------------------------------------------------------------------------

function initSlider( el, index ) {
	const speedModifier = index * 300;
	const itemsMobile  = +el.dataset.itemsMobile  || 1;
	const itemsTablet  = +el.dataset.itemsTablet  || 2;
	const itemsDesktop = +el.dataset.itemsDesktop || 3;
	const speed        = +el.dataset.speed        || 300;
	const delay        = +el.dataset.delay        || 6000;
	const spaceBetween = +el.dataset.spaceBetween || 24;
	const enableLoop   = el.dataset.enableLoop    === 'true';
	const enableNav    = el.dataset.enableNav     === 'true';
	const enablePaging = el.dataset.enablePagination === 'true';

	const config = {
		slidesPerView: itemsMobile,
		speed,
		spaceBetween,
		loop: enableLoop,
		autoplay: {
			delay: delay + speedModifier,
			pauseOnMouseEnter: true,
		},
		breakpoints: {
			840:  { slidesPerView: itemsTablet },
			1200: { slidesPerView: itemsDesktop },
		},
	};

	if ( enablePaging ) {
		config.pagination = {
			el: el.querySelector( '.chalk-nursery-locations__pagination' ),
			clickable: true,
		};
	}

	if ( enableNav ) {
		config.navigation = {
			nextEl: el.querySelector( '.chalk-nursery-locations__btn-next' ),
			prevEl: el.querySelector( '.chalk-nursery-locations__btn-prev' ),
		};
	}

	new Swiper( el, config );
}

// ---------------------------------------------------------------------------
// Boot
// ---------------------------------------------------------------------------

document.addEventListener( 'DOMContentLoaded', () => {
	document
		.querySelectorAll( '.chalk-nursery-locations--grid' )
		.forEach( initGrid );

	document
		.querySelectorAll( '.chalk-nursery-locations--slider.swiper' )
		.forEach( ( el, i ) => initSlider( el, i ) );
} );
